import { request } from './client';
import type { DebtPaymentInput, DebtPaymentResult, DebtReverseResult } from '@kassa/shared';

export const debtApi = {
  debtPay: (customerId: string, body: DebtPaymentInput) =>
    request<DebtPaymentResult>('POST', `/api/customers/${encodeURIComponent(customerId)}/payments`, body),
  debtReverse: (paymentId: string, id: string) =>
    request<DebtReverseResult>('POST', `/api/customers/payments/${encodeURIComponent(paymentId)}/reverse`, { id }),
};
